document.querySelectorAll(".clp-grid").forEach((item) => {
  item.addEventListener("click", (event) => {
    //handle click
    if (window.innerWidth < 768) {
      localStorage.setItem("grid-mobile", item.getAttribute("data-grid-type"));
    } else {
      localStorage.setItem("grid", item.getAttribute("data-grid-type"));
    }
    window.updateGrid(item.classList.value);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 768) {
    window.updateGrid(localStorage.getItem("grid-mobile"))
      ? window.updateGrid(localStorage.getItem("grid-mobile"))
      : "";
  } else {
    window.updateGrid(localStorage.getItem("grid"))
      ? window.updateGrid(localStorage.getItem("grid"))
      : "";
  }
});
setGridCLP();
window.onresize = setGridCLP();

function setGridCLP() {
  window["updateGrid"] = function (gridType) {
    document.querySelectorAll(".clp-grid").forEach((element) => {
      element.classList.remove("active");
    });
    if (window.innerWidth < 768) {
      if (gridType?.includes("single-grid")) {
        document.querySelector(".multiple-grid").classList.add("active");
        document.querySelector(".main-grid").classList.add("single-grid");
      } else {
        document.querySelector(".single-grid").classList.add("active");
        document.querySelector(".main-grid").classList.remove("single-grid");
      }
    } else {
      if (gridType?.includes("four-grid")) {
        document.querySelector(".three-grid").classList.add("active");
        document.querySelector(".main-grid").classList.add("four-grid");
      } else {
        document.querySelector(".four-grid").classList.add("active");
        document.querySelector(".main-grid").classList.remove("four-grid");
      }
    }
  };
}